
define('text!modules/T1App/templates/header.html',[],function () { return '<div class="basic-info">\n\t<div class="info">\n\t\t<div class="title test">\n\t\t\t<strand-header size="{{#subTitle}}small{{/subTitle}}{{^subTitle}}medium{{/subTitle}}" unresolved>{{title}}</strand-header>\n\t\t</div>\n\t</div>\n</div>';});

